import { useCallback, useEffect, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import screens from '../../../screens';
import { shouldShowTooltip, tooltipDetails } from '../../../state/actions/tooltip';
import { MissionsIconTooltipDetail } from '../tooltips';
import { getText, TEXT_KEY } from '../../../utils/localization';
import { hasUnderMaintenanceState } from '../utils/missionsPerformance';
var TOOLTIP_DURATION = 2000;
var INITIAL_DELAY = 2000;
var useMissionsIconTooltip = function useMissionsIconTooltip(_ref) {
  var missionsState = _ref.missionsState,
    navigation = _ref.navigation,
    _ref$isVerticalMenu = _ref.isVerticalMenu,
    isVerticalMenu = _ref$isVerticalMenu === void 0 ? false : _ref$isVerticalMenu;
  var dispatch = useDispatch();
  var _useSelector = useSelector(function (state) {
      return {
        modal: state.modal.modal,
        actionCommands: state.actionCommands.actions,
        showTooltip: state.tooltip.shouldShowTooltip
      };
    }, shallowEqual),
    modal = _useSelector.modal,
    actionCommands = _useSelector.actionCommands,
    showTooltip = _useSelector.showTooltip;
  var firstCycle = useRef(true);
  var hasChecked = useRef(false);
  var actionCommandsRef = useRef(actionCommands);
  var showTooltipRef = useRef(showTooltip);
  var triggerTooltip = useCallback(function () {
    var _actionCommandsRef$cu;
    var checkActions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (checkActions && (((_actionCommandsRef$cu = actionCommandsRef.current) === null || _actionCommandsRef$cu === void 0 ? void 0 : _actionCommandsRef$cu.length) > 0 || showTooltipRef !== null && showTooltipRef !== void 0 && showTooltipRef.current)) return;
    hasChecked.current = true;
    var detail = MissionsIconTooltipDetail(getText(TEXT_KEY.UNDER_MAINTENANCE));
    dispatch(tooltipDetails(detail));
    dispatch(shouldShowTooltip(true));
    setTimeout(function () {
      dispatch(shouldShowTooltip(false));
    }, TOOLTIP_DURATION);
  });
  var missionUnderMaintenance = hasUnderMaintenanceState(missionsState);
  var showTooltipOnAppOpen = useCallback(function () {
    if (isVerticalMenu) return;
    if (firstCycle.current) {
      firstCycle.current = false;
      return;
    }
    if (modal || (actionCommands === null || actionCommands === void 0 ? void 0 : actionCommands.length) !== 0 || navigation.state.routes[navigation.state.index].key !== screens.Home || hasChecked.current || !missionUnderMaintenance) return;
    setTimeout(function () {
      triggerTooltip(true);
    }, INITIAL_DELAY);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [missionUnderMaintenance, modal, actionCommands]);
  useEffect(function () {
    return showTooltipOnAppOpen();
  }, [showTooltipOnAppOpen]);
  return {
    triggerTooltip: triggerTooltip
  };
};
export default useMissionsIconTooltip;